import { ReactNode } from 'react';
import { css } from '@emotion/react';

import { ProductCardCarousel } from '@common/product-card';

export interface VerticalProductCardCarouselContainerProps
  extends ProductCardCarousel.VerticalProductCardSlideItemsProps {
  title?: ReactNode;
}

export const VerticalProductCardCarouselContainer = (props: VerticalProductCardCarouselContainerProps) => {
  const { title, items, onClick, onImpression, onLikeClick, defaultSize, productNameLineClamp } = props;

  const slideItemsProps = {
    items,
    onClick,
    onImpression,
    onLikeClick,
    defaultSize,
    productNameLineClamp,
  } as Omit<typeof props, 'title'>;

  return (
    <section css={wrapperCss}>
      {title ?? ''}
      <ProductCardCarousel.Root>
        <ProductCardCarousel.VerticalProductCardSlideItems {...slideItemsProps} />
      </ProductCardCarousel.Root>
    </section>
  );
};

const wrapperCss = css`
  padding: 0 0 36px;
`;
